export default __webpack_public_path__ + "static/media/login-back.50286287.png";